import axios from '../../app/common/libs/http';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchUsersData = createAsyncThunk(
  'admin-user-data',
  async (accountId, { getState }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_APIURL}/user/getAllUsersData/${accountId}`
    );

    if (response && response.data) {
      //user data from redux state
      const userState = getState().auth.user;
      //filter & remove user data from list
      const updateUserList = response.data.filter((d) => d.id != userState.Id);
      //update response data
      response.data = updateUserList;
      return response;
    }
  }
);

export const registerUser = createAsyncThunk(
  'admin-create-user',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/user/addUser`,
        data
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility

      if (err.response.data.errors) {
        if (err.response.data.errors.User)
          return rejectWithValue({ Errors: err.response.data.errors.User });
      }

      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchUpdateUser = createAsyncThunk(
  'admin-update-user',
  async (data, { rejectWithValue }) => {
    console.log('update user API ');
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/user/updateUser`,
        data
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility

      if (err.response.data.errors) {
        if (err.response.data.errors.User)
          return rejectWithValue({ Errors: err.response.data.errors.User });
      }

      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchDeleteUser = createAsyncThunk(
  'admin-delete-user',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/user/deleteUserData`,
        data
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility

      if (err.response.data.errors) {
        if (err.response.data.errors.User)
          return rejectWithValue({ Errors: err.response.data.errors.User });
      }

      return rejectWithValue(err.response.data);
    }
  }
);

export const updateOnBoardingStatus = createAsyncThunk(
  'admin-update-onboarding-status',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APIURL}/user/updateOnBoardingStatus/${userId}`
      );
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility

      if (err.response.data.errors) {
        if (err.response.data.errors.User)
          return rejectWithValue({ Errors: err.response.data.errors.User });
      }

      return rejectWithValue(err.response.data);
    }
  }
);
